import {decorate, observable, action} from "mobx"
import {defaultGeo, getCurrentTime, defaultMapGeos} from "../../utils/utils"
import {TimePeriodStore} from "./timePeriodStore"
import randomInt from "random-int"

export class DisStore {
  timePeriod = new TimePeriodStore().timePeriod

  setTableDataError(bool) {
    this.tableDataError = bool
  }

  setBrandCat(brandId, sicCode) {
    this.brandId = brandId
    this.sicCode = sicCode
  }

  brandId = null
  setBrandId(brandId) {
    this.brandId = brandId
  }

  sicCode = null
  setSicCode(sicCode) {
    this.sicCode = sicCode
  }

  catSearchBool = false
  setCatSearchBool() {
    this.catSearchBool = !this.catSearchBool
  }

  geoTimeObj = {
    geo: defaultGeo,
    timePeriod: this.timePeriod,
  }

  //use this for useEffect for top ten geo service request
  geoServiceObj = {
    selected: null,
    timePeriod: this.timePeriod,
  }

  mapGeoObj = this.geoServiceObj

  //GT map component state/dma distribution params
  mapGeos = defaultMapGeos

  showLoader = true //GT map component loader boolean

  geoNonePOI = this.geoTimeObj.geo //use this obj when returning to discovery brands from locations
  setGeoNonePOI(obj) {
    this.geoNonePOI = obj
  }

  setGeoTimeObj(newGeoTimeObj) {
    this.geoTimeObj = {...this.geoTimeObj, ...newGeoTimeObj}
  }
  //GT map component - update request IDs upon new map data
  updateMapGeoRequest() {
    const [requestId1, requestId2] = Array(2).fill(randomInt(10000))
    this.mapGeos.STATE.requestId = requestId1
    this.mapGeos.DMA.requestId = requestId2
  }

  setGeoServiceObj(newPoiServiceObj) {
    this.geoServiceObj = {...this.geoServiceObj, ...newPoiServiceObj}
  }

  setMapGeoObj(newPoiServiceObj) {
    this.mapGeoObj = {...this.mapGeoObj, ...newPoiServiceObj}
  }

  setMapGeos(newGeos) {
    this.mapGeos = {...this.mapGeos, ...newGeos}
  }

  setShowLoader(bool) {
    this.showLoader = bool
  }

  cachedCountryData = []
  cachedCountryTime = new Date()
  setCachedCountryData(data, time) {
    const filteredData = this.filterData(data)
    this.cachedCountryData = filteredData
    this.cachedCountryTime = time
  }

  isCategoryPresent(sicCode) {
    let isPresent = false
    const topData =
      this.geoTimeObj.geo.geoType === "COUNTRY" &&
      this.geoTimeObj.timePeriod === "SEVEN_DAYS"
        ? this.cachedCountryData
        : this.tableStates.tableData
    topData.forEach((row) => {
      if (row.sicCode === sicCode) {
        isPresent = true
      }
    })
    return isPresent
  }

  isBrandPresent(sicCode, id) {
    let brandPresent = false
    const topData =
      this.geoTimeObj.geo.geoType === "COUNTRY" &&
      this.geoTimeObj.timePeriod === "SEVEN_DAYS"
        ? this.cachedCountryData
        : this.tableStates.tableData
    topData.forEach((row) => {
      if (row.sicCode === sicCode) {
        row.brands.forEach((brand) => {
          if (brand.id === id) {
            brandPresent = true
          }
        })
      }
    })
    return brandPresent
  }

  //update country cache brands on brand selection, remove previous selection
  handleBrandCache(cat, brandId) {
    let included = false
    const result = []
    const brands = cat.brands

    for (let i = 0; i < brands.length; i++) {
      if (i <= 9) {
        if (brands[i].id === brandId) included = true
        result.push(brands[i])
      }

      if (!included) {
        if (brands[i].id === brandId) result.push(brands[i])
      }
    }

    return result
  }

  //update country cache based on brand selection, remove previous selection
  handleModifyCountryCache(newTableData, sicCode, brandId = null) {
    return newTableData.reduce((result, cat, idx) => {
      let included = false
      if (idx <= 9) {
        if (cat.sicCode === sicCode) included = true

        if (brandId) {
          let brands = this.handleBrandCache(cat, brandId)
          cat.brands = brands
        }

        result.push(cat)
      }

      if (!included) {
        if (cat.sicCode === sicCode) {
          result.push(cat)
        }
      }

      return result
    }, [])
  }

  handleExistingCategorySearch(sicCode) {
    // debugger;
    const isCountry = this.geoTimeObj.geo.geoType === "COUNTRY"
    let newTableData = this.tableStates.tableData

    //store searched cat in cached country if geo is country
    if (isCountry && this.geoTimeObj.timePeriod === "SEVEN_DAYS") {
      newTableData = this.handleModifyCountryCache(this.cachedCountryData, sicCode)
      this.setCachedCountryData(newTableData, getCurrentTime()) // COUNTRY TOP 10 Cache
    }

    this.setTableStates({
      tableDataLoading: false,
      tableData: newTableData,
      selected: sicCode,
      isBrandSelected: false,
      expandedRow: sicCode,
    })
    this.setGeoServiceObj({selected: sicCode})
  }

  handleNewCategorySearch(item) {
    // debugger;
    if (item.name) {
      let addItem = true
      const isCountry = this.geoTimeObj.geo.geoType === "COUNTRY"
      const topData =
        isCountry && this.geoTimeObj.timePeriod === "SEVEN_DAYS"
          ? this.cachedCountryData
          : this.tableStates.tableData
      let brandsList =
        item.brands && item.brands.filter((brand) => (brand.name ? true : false))
      item.brands = brandsList
      let newTableData = []

      topData.forEach((row) => {
        if (this.catSearchBool && isCountry && row.sicCode === item.sicCode) {
          row = item
          this.setCatSearchBool()
          addItem = false
        }
        newTableData.push(row) //push row no matter match or not
      })

      if (addItem) {
        let newRow = item
        newTableData.push(newRow)
      }

      //store searched cat in cached country if geo is country
      if (isCountry && this.geoTimeObj.timePeriod === "SEVEN_DAYS") {
        newTableData = this.handleModifyCountryCache(newTableData, item.sicCode)
        this.setCachedCountryData(newTableData, getCurrentTime()) // COUNTRY TOP 10 Cache
      }
      this.setBrandCat(null, item.sicCode)
      this.setGeoServiceObj({selected: item.sicCode})
      this.setTableStates({
        tableDataLoading: false,
        tableData: newTableData,
        selected: item.sicCode,
        isBrandSelected: false,
        expandedRow: item.sicCode,
      })
    }
  }

  handleExistingBrandSearch(sicCode, id) {
    const isCountry = this.geoTimeObj.geo.geoType === "COUNTRY"
    let newTableData = this.tableStates.tableData

    //store searched brand in cached country if geo is country
    if (isCountry && this.geoTimeObj.timePeriod === "SEVEN_DAYS") {
      newTableData = this.handleModifyCountryCache(this.cachedCountryData, sicCode, id)
      this.setCachedCountryData(newTableData, getCurrentTime()) // COUNTRY TOP 10 Cache
    }
    this.setBrandCat(id, null)
    this.setGeoServiceObj({selected: id})
    this.setTableStates({
      tableDataLoading: false,
      tableData: newTableData,
      selected: id,
      expandedRow: sicCode,
    })
  }

  handleNewBrandSearch(item) {
    if (item.name && item.category && item.category.name) {
      // let addItem = true;
      const isCountry = this.geoTimeObj.geo.geoType === "COUNTRY"
      const topData =
        isCountry && this.geoTimeObj.timePeriod === "SEVEN_DAYS"
          ? this.cachedCountryData
          : this.tableStates.tableData
      let newTableData = [] // Creating a new array for data to avoid mutating directly
      let isCategoryPresent = false
      const {id, name, locations, visits} = item

      topData.forEach((row) => {
        if (row.sicCode === item.category.sicCode) {
          // Category exists already
          isCategoryPresent = true
          let newrow = {
            // 1 Brand not exist in the cat (cat exist)
            ...row,
            brands: [
              // build a new row, with updated brands
              ...row.brands,
              {id, name, locations, visits},
            ],
          }
          newTableData.push(newrow)
        } else {
          // category not match, just push original cat row.
          newTableData.push(row)
        }
      })

      if (!isCategoryPresent) {
        //2 looped all rows, category is not present
        // build a new row, with new cat and new brands.
        let newrow = {
          ...item.category,
          brands: [{id, name, locations, visits}],
        }
        newTableData.push(newrow)
      }

      //store searched brand in cached country if geo is country
      if (isCountry && this.geoTimeObj.timePeriod === "SEVEN_DAYS") {
        newTableData = this.handleModifyCountryCache(newTableData, item.sicCode, item.id)
        this.setCachedCountryData(newTableData, getCurrentTime()) // COUNTRY TOP 10 Cache
      }
      this.setBrandCat(id, null)
      this.setGeoServiceObj({selected: item.id})
      this.setTableStates({
        tableDataLoading: false,
        tableData: newTableData,
        selected: item.id,
        isBrandSelected: true,
        expandedRow: item.category.sicCode,
      })
    }
  }

  tableStates = {
    tableDataLoading: true,
    tableData: null,
    tableDataError: false,
    retryCount: 0,
    selected: null,
    isBrandSelected: false,
    expandedRow: null,
  }

  setTableStates(newTableStates) {
    this.tableStates = {...this.tableStates, ...newTableStates}
  }

  //setting top 10 data and optional user brand/category selection
  setDataAndId(resultsTop, resultsBrand, resultsCategory) {
    const filteredData = this.filterData(resultsTop) //filter data

    if (filteredData.length === 0) {
      this.setTableStates({tableDataLoading: false, tableDataError: true})
    } else {
      this.setTableStates({tableData: filteredData}) //set filtered data into tableStates

      if (resultsTop && resultsBrand) {
        //top 10 data with user brand selection

        const {id, sicCode} = resultsBrand //get id and sicCode
        const isBrandPresent = this.isBrandPresent(sicCode, id) //get brand presence

        if (!isBrandPresent) this.handleNewBrandSearch(resultsBrand)
        //add brand to top 10 if not present
        else this.handleExistingBrandSearch(sicCode, id)
      } else if (resultsTop && resultsCategory) {
        const {sicCode} = resultsCategory //get sicCode
        const isCategoryPresent = this.isCategoryPresent(sicCode) //get category presence

        if (!isCategoryPresent) this.handleNewCategorySearch(resultsCategory)
        //add category to top10 if not present
        else this.handleExistingCategorySearch(sicCode)
      } else {
        if (!this.tableStates.isBrandSelected && this.tableStates.expandedRow === null) {
          this.brandId = null
          this.sicCode = filteredData[0].sicCode || null
          this.setTableStates({
            tableDataLoading: false,
            tableData: filteredData,
            selected: this.sicCode,
            expandedRow: this.sicCode,
          })
          this.setGeoServiceObj({selected: this.sicCode}) //update
        } else this.setTableStates({tableDataLoading: false, tableData: filteredData})
      }
    }
  }

  filterData(data) {
    if (data) {
      let filteredCats = data.filter((category) =>
        category !== null && category.name ? true : false
      )
      filteredCats.forEach((category) => {
        let brandsList = category.brands.filter((brand) =>
          brand !== null && brand.name ? true : false
        )
        category.brands = brandsList
      })
      return filteredCats
    }
  }
}

decorate(DisStore, {
  brandId: observable,
  setBrandId: action,

  sicCode: observable,
  setSicCode: action,

  catSearchBool: observable,
  setCatSearchBool: action,

  timePeriod: observable,

  cachedCountryData: observable,
  setCachedCountryData: action,

  setStateName: action,
  setBrandCat: action,

  tableStates: observable,
  setTableStates: action,
  tableDataError: observable,
  setTableDataError: action,

  geoTimeObj: observable,
  setGeoTimeObj: action,

  isCategoryPresent: action,
  isBrandPresent: action,
  handleExistingCategorySearch: action,
  handleNewCategorySearch: action,
  handleExistingBrandSearch: action,
  handleNewBrandSearch: action,
  resetToNational: action,
  filterData: action,
  handleBrandCache: action,
  handleModifyCountryCache: action,

  geoServiceObj: observable,
  setGeoServiceObj: action,

  mapGeos: observable,
  setMapGeos: action,

  mapGeoObj: observable,
  setMapGeoObj: action,

  updateMapGeoRequest: action,

  showLoader: observable,
  setShowLoader: action,
})
